module.exports = __webpack_public_path__ + "resources/img/logo_nhn_cloud_color_gov.dce1a8ae7c3fb772206855f390c9c234.svg";